import { render, staticRenderFns } from "./BuildingType.vue?vue&type=template&id=1ff76b60&scoped=true&"
import script from "./BuildingType.vue?vue&type=script&lang=js&"
export * from "./BuildingType.vue?vue&type=script&lang=js&"
import style0 from "./BuildingType.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BuildingType.vue?vue&type=style&index=1&id=1ff76b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff76b60",
  null
  
)

export default component.exports